<template>
  <div
    class="h-full w-full"
    id="appContent"
    :class="{
      '[&_.mobile-status-padding]:pt-12 [&_.mobile-bottom-padding]:pt-8 [&_.mobile-status-padding-mt]:mt-12 need-mobile-app-padidngs':
        $stores.shared?.state?.isAndroidApp
    }"
  >
    <div class="w-full h-full overflow-auto flex">
      <div class="h-full flex" v-if="!['login', 'welcome', 'register'].includes($route.name)">
        <MenuPannel />
      </div>
      <div class="w-full overflow-auto flex flex-col md:px-16" style="background-color: var(--bg-page)">
        <Transition
          mode="out-in"
          appear
          enter-active-class="transition-opacity duration-500"
          enter-from-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="transition-opacity duration-300"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
          duration="200"
        >
          <div class="w-full h-full overflow-auto" :key="$route.fullPath">
            <slot></slot>
          </div>
        </Transition>
      </div>
    </div>
    <div class="hidden">
      <!-- <ImgComponent avatar defaultAvatarStyle="miniavs" src="you" alt="" /> -->
    </div>
  </div>
</template>
